import {
  TOGGLE_MODAL,
  RESET_MODAL
} from './types';

export const toggleModal = () => ({
  type: TOGGLE_MODAL,
});

export const resetModal = () => ({
  type: RESET_MODAL
})
